import { render } from "./ChannelTest.vue?vue&type=template&id=292b77dd&ts=true"
import script from "./ChannelTest.vue?vue&type=script&lang=ts"
export * from "./ChannelTest.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__